import { resetCheckoutOnReturn, hasPendingCartItem } from './pilot-checkout-state.js?v=1';
import { startAtcLoading } from './pilot-atc-loading.js?v=1';
import { checkoutAfterGifts } from './direct-checkout-theme.js?v=gift-copy-d844a9e6b04d';
import { CartAddEvent } from '@theme/events';

function initialise(root) {
  if (root.dataset.initialised) return;
  root.dataset.initialised = 'true';
  const form = root.querySelector('[data-essentae-offer-form]');
  resetCheckoutOnReturn(root, form);
  const cards = [...root.querySelectorAll('.product-offer__variant-item')];
  const subscribe = root.querySelector('[data-subscribe]');
  const planInput = form.querySelector('[name="selling_plan"]');
  const error = root.querySelector('[data-offer-error]');
  let selected = cards.find(card => card.classList.contains('selected')) || cards[0];
  const sync = () => {
    if (!selected) return;
    form.elements.id.value = selected.dataset.id;
    const isSubscription = Boolean(subscribe?.checked && selected.dataset.plan);
    cards.forEach(card => {
      const active = card === selected;
      card.classList.toggle('selected', active);
      card.setAttribute('aria-pressed', String(active));
      card.querySelector('.price').textContent = isSubscription && card.dataset.planPrice ? card.dataset.planPrice : card.dataset.price;
      const compare = card.querySelector('.compare-price');
      compare.hidden = !(isSubscription || card.dataset.onceCompare);
      compare.textContent = isSubscription ? card.dataset.price : (card.dataset.onceCompare || '');
      const saving = card.querySelector('.product-offer__variant-saving');
      const savingPercent = isSubscription ? Number(card.dataset.saving) : Number(card.dataset.onceSaving);
      saving.hidden = !(savingPercent > 0);
      saving.textContent = (card.dataset.saveLabel || '').replace('{percent}', String(savingPercent));
    });
    root.querySelectorAll('.btn-price').forEach(el => el.textContent = isSubscription ? selected.dataset.planPrice : selected.dataset.price);
    root.querySelectorAll('[data-buy-once-price]').forEach(el => el.textContent = selected.dataset.price);
    root.querySelectorAll('.btn-compare').forEach(el => { const showCompare = isSubscription || Boolean(selected.dataset.onceCompare); el.hidden = !showCompare; el.style.display = showCompare ? 'inline' : 'none'; el.textContent = isSubscription ? selected.dataset.price : (selected.dataset.onceCompare || ''); });
    if (subscribe) {
      subscribe.disabled = !selected.dataset.plan;
      if (subscribe.disabled) subscribe.checked = false;
      planInput.disabled = !subscribe.checked;
      planInput.value = subscribe.checked ? selected.dataset.plan : '';
      root.querySelector('.product-offer__subscription-description').textContent = selected.dataset.planLabel || '';
      const renewal=root.querySelector('[data-amla-renewal]');
      if(renewal){
        const label=selected.dataset.planLabel || '';
        renewal.textContent=`${renewal.dataset.renewalPrefix} ${label.charAt(0).toLowerCase()+label.slice(1)}`;
      }
    }
  };
  cards.forEach(card => card.addEventListener('click', () => { selected = card; sync(); }));
  subscribe?.addEventListener('change', sync);
  root.querySelector('[data-buy-once]')?.addEventListener('click', () => {
    if (subscribe) subscribe.checked = false;
    sync();
    form.requestSubmit();
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (form.dataset.submitting || !selected) return;
    form.dataset.submitting = 'true';
    const finishLoading = startAtcLoading(root);
    error.hidden = true;
    const buttons = [...root.querySelectorAll('button[type="submit"],[data-buy-once]')];
    buttons.forEach(button => button.disabled = true);
    try {
      if (await hasPendingCartItem(form)) { await checkoutAfterGifts(root); return; }
      const data = new FormData(form);
      const submittedVariant = String(data.get("id"));
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))];
      if (sections.length) data.set('sections', sections.join(','));
      data.set('sections_url', location.pathname);
      const response = await fetch(form.action.replace(/\.js$/, '') + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || response.statusText);
      if (root.dataset.directCheckout === 'true') { form.dataset.checkoutPending = 'true'; await checkoutAfterGifts(root); return; }
      root.dispatchEvent(new CartAddEvent(cart, submittedVariant, {
        source: 'product-form-component', itemCount: 1,
        productId: root.dataset.productId, variantId: submittedVariant,
        sections: cart.sections, properties: {}
      }));
    } catch (failure) {
      error.textContent = failure.message;
      error.hidden = false;
    } finally {
      delete form.dataset.submitting;
      buttons.forEach(button => button.disabled = false);
      finishLoading();
    }
  });
  const sticky = root.querySelector('.product-offer__sticky');
  const wrapper = root.querySelector('.product-offer__wrapper');
  const footer = document.querySelector('.site-footer, footer');
  if (sticky && wrapper) {
    const lifecycle = new AbortController();
    const updateSticky = () => {
      if (!root.isConnected) { lifecycle.abort(); return; }
      const passedOffer = wrapper.getBoundingClientRect().bottom <= 0;
      const overlapsFooter = footer && sticky.getBoundingClientRect().bottom >= footer.getBoundingClientRect().top;
      sticky.classList.toggle('visible', passedOffer && !overlapsFooter);
    };
    window.addEventListener('scroll', updateSticky, { passive: true, signal: lifecycle.signal });
    window.addEventListener('resize', updateSticky, { passive: true, signal: lifecycle.signal });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) lifecycle.abort();
    }, { signal: lifecycle.signal });
    root.querySelector('.product-offer__sticky-btn')?.addEventListener('click', () => {
      root.querySelector('#product-offer')?.scrollIntoView({ behavior: 'smooth' });
    });
    updateSticky();
  }
  sync();
}
document.querySelectorAll('[data-essentae-amla]').forEach(initialise);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-essentae-amla]').forEach(initialise));
